import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Slide,
  Stack,
  Typography,
} from '@mui/material';
import RiceBowlRoundedIcon from '@mui/icons-material/RiceBowlRounded';
import { TransitionProps } from '@mui/material/transitions';
import { useTheme } from '@mui/material/styles';
import { forwardRef } from 'react';

const SlideUp = forwardRef(function SlideUp(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function RiceDialog({
  openRiceDialog,
  handleCloseRiceDialog,
  handleSelectRice,
  selectedRice,
  setSelectedRice,
  t,
}) {
  const theme = useTheme();

  const optionStyle = (active) => ({
    px: 2,
    py: 1.5,
    borderRadius: 2,
    border: `1px solid ${active ? theme.palette.primary.main : theme.palette.divider}`,
    backgroundColor: active ? theme.palette.action.hover : theme.palette.background.paper,
    transition: 'all .25s ease',
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    },
  });

  return (
    <Dialog
      open={openRiceDialog}
      onClose={handleCloseRiceDialog}
      TransitionComponent={SlideUp}
      fullWidth
      maxWidth="xs"
      PaperProps={{ sx: { borderRadius: 3, p: 0 } }}
    >
      <DialogTitle
        sx={{
          pt: 3,
          pb: 2,
          textAlign: 'center',
          fontWeight: 600,
          fontSize: 18,
        }}
      >
        {t('اختر نوع الرز')}
      </DialogTitle>

      <Divider />

      <DialogContent sx={{ pt: 3, pb: 0 }}>
        <FormControl fullWidth component="fieldset">
          <RadioGroup
            value={selectedRice}
            onChange={(e) => setSelectedRice(e.target.value)}
          >
            <Stack spacing={1.5}>
              <FormControlLabel
                value="1"
                control={<Radio size="small" />}
                label={
                  <Stack direction="row" spacing={1} alignItems="center">
                    <RiceBowlRoundedIcon fontSize="small" />
                    <Typography>{t('رز شعبي')}</Typography>
                  </Stack>
                }
                sx={{ ...optionStyle(selectedRice === '1'), width: 400 }}
              />

              <FormControlLabel
                value="2"
                control={<Radio size="small" />}
                label={
                  <Stack direction="row" spacing={1} alignItems="center">
                    <RiceBowlRoundedIcon fontSize="small" />
                    <Typography>{t('رز بيشاور')}</Typography>
                  </Stack>
                }
                sx={{ ...optionStyle(selectedRice === '2'), width: 400 }}
              />
            </Stack>
          </RadioGroup>
        </FormControl>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2.5, pt: 1.5, justifyContent: 'space-between' }}>
        <Button onClick={handleCloseRiceDialog}>{t('إلغاء')}</Button>
        <Button
          onClick={() => handleSelectRice(selectedRice)}
          disabled={!selectedRice}
          variant="contained"
        >
          {t('تأكيد')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}